export enum TextEditorAttachmentType {
    None = 0,
    Youtube = 1, // link type
    Image = 2, // link type
    Video = 3,
    MBImage = 4,
    Gif = 5, // link type
}
